import React from 'react';
import TooltipBody from 'modules/emergencies/components/ui/texts/TooltipBody';
import TooltipHeader from 'modules/emergencies/components/ui/texts/TooltipHeader';
import styled from 'styled-components';
import ADDITIONAL_SERVICES from '../../../../constants/additionalServices';

const UnorderedList = styled.ul`
  margin: 0;
  margin-left: -20px;
`;

const serviceText = Object.fromEntries(
  ADDITIONAL_SERVICES.map((service) => [service.value, service.label])
);
export const ServicesTooltip = ({ ticket }) => {
  const services = ticket.order_data?.complementary_info?.additional_services;
  const head = services.length > 0 ? 'Additional services' : 'No additional services';
  const body = services.map((service) => serviceText[service] || service);
  return (
    <>
      <TooltipHeader>{head}</TooltipHeader>
      {services.length > 0 && (
        <UnorderedList>
          {body.map((service) => (
            <li key={service}>
              <TooltipBody>{service}</TooltipBody>
            </li>
          ))}
        </UnorderedList>
      )}
    </>
  );
};
